export default __webpack_public_path__ + "static/rbds-283dd4e6a62771141d6790d6c38f7fdc.mp4";